<template>
  <!-- 视频监控 videoSurveillance-->
  <div class="videoSurveillance">
    <div class="con">
      <div class="tree-left">
        <el-scrollbar style="height:98%;width: 100%;">
          <div class="item active">
            <img src="@/assets/zhineng/jk1.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk2.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk3.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk4.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk5.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk6.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk7.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk8.png" alt="">
          </div>
          <div class="item">
            <img src="@/assets/zhineng/jk9.png" alt="">
          </div>
        </el-scrollbar>
      </div>
      <div class="right-table">
        <div class="myvideo">
          <video ref="videoPlayer" controls loop autoplay style="width: 100%;height: 100%;">
            <source src="../../../public/static/image/elTree/shipin.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    data () {
      return {

      };
    },

    mounted () {
      this.$refs.videoPlayer.load();
    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .videoSurveillance {

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .tree-left {
      width: 300px;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .item {
        padding: 4px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 120px;
        border: 2px solid #e6e6e6;
        margin-bottom: 12px;

        &.active {
          border-color: #368ED9;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .myvideo {
        width: 100%;
        height: 100%;
        background-color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

  }
</style>